import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  configString: "",
  orderRowDescription: "",
  purchasePrice: "",
  language: "",
  productAttributes: [],
};

const addToCartSlice = createSlice({
  name: "addToCart",
  initialState,
  reducers: {
    setConfigString(state, action) {
      state.configString = action.payload;
    },
    setOrderRowDescription(state, action) {
      state.orderRowDescription = action.payload;
    },
    setPurchasePrice(state, action) {
      state.purchasePrice = action.payload;
    },
    setLanguage(state, action) {
      state.language = action.payload;
    },
    setProductAttributes(state, action) {
      state.productAttributes = action.payload;
    },
  },
});

export const { 
  setConfigString, 
  setOrderRowDescription, 
  setPurchasePrice, 
  setLanguage, 
  setProductAttributes
} = addToCartSlice.actions;

export default addToCartSlice.reducer;
